export default __webpack_public_path__ + "static/media/triangleparkingwebsite.85ae0ff9.png";